import { render, staticRenderFns } from "./ManageDeliveryRegisterView.vue?vue&type=template&id=510556f4&scoped=true"
import script from "./ManageDeliveryRegisterView.vue?vue&type=script&lang=ts"
export * from "./ManageDeliveryRegisterView.vue?vue&type=script&lang=ts"
import style0 from "./ManageDeliveryRegisterView.vue?vue&type=style&index=0&id=510556f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510556f4",
  null
  
)

export default component.exports